import { render, staticRenderFns } from "./SwiperList.vue?vue&type=template&id=41249262&scoped=true"
import script from "./SwiperList.vue?vue&type=script&lang=js"
export * from "./SwiperList.vue?vue&type=script&lang=js"
import style0 from "./SwiperList.vue?vue&type=style&index=0&id=41249262&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41249262",
  null
  
)

export default component.exports